export enum SettingsPageActions {
  showPaywall,
}
